import {
  CustomerInvitationsActions,
  CustomerInvitationsActionTypes
} from '@appStore/customers/actions/customer-invitations.actions';
import { UserInvitation } from '@model';

export interface State {
  invitations: UserInvitation[];
  invitationsLoading: boolean;
  invitationsLoaded: boolean;
  invitation: UserInvitation;
  creating: boolean;
  created: boolean;
  bulkInvitationsCreating: boolean;
  bulkInvitationsCreated: boolean;
  bulkInvitationsCompleted: boolean;
  removing: boolean;
  removed: boolean;
}

export const initialState: State = {
  invitations: [],
  invitationsLoading: false,
  invitationsLoaded: false,
  invitation: null,
  created: false,
  creating: false,
  bulkInvitationsCreating: false,
  bulkInvitationsCreated: false,
  bulkInvitationsCompleted: false,
  removing: false,
  removed: false
};

export function reducer(state = initialState, action: CustomerInvitationsActions): State {
  switch (action.type) {
    case CustomerInvitationsActionTypes.BulkCreateCustomerInvitations:
      return { ...state, creating: true, created: false };

    case CustomerInvitationsActionTypes.BulkCreateCustomerInvitationsSuccess:
      const addedData = action.payload.filter(x => state.invitations.every(y => y.id !== x.id));
      return {
        ...state,
        creating: false,
        created: true,
        invitations:
          action.payload === null
            ? []
            : addedData.some(d => d.existingUser)
            ? state.invitations
            : [...state.invitations, ...addedData]
      };
    case CustomerInvitationsActionTypes.BulkCreateCustomerInvitationsFail:
      return {
        ...state,
        creating: false,
        created: false,
        invitations: []
      };

    case CustomerInvitationsActionTypes.BulkCreateCustomersInvitations:
      return { ...state, bulkInvitationsCreating: true, bulkInvitationsCreated: false, bulkInvitationsCompleted: false };

    case CustomerInvitationsActionTypes.BulkCreateCustomersInvitationsSuccess:
      return {
        ...state,
        bulkInvitationsCreating: false,
        bulkInvitationsCreated: true,
        bulkInvitationsCompleted: false
      };
    case CustomerInvitationsActionTypes.BulkCreateCustomersInvitationsFail:
      return {
        ...state,
        bulkInvitationsCreating: false,
        bulkInvitationsCreated: false,
        bulkInvitationsCompleted: false,
        invitations: []
      };
    case CustomerInvitationsActionTypes.BulkCreateCustomersInvitationsCompleted:
      return {
        ...state,
        bulkInvitationsCompleted: action.payload
      };

    case CustomerInvitationsActionTypes.CustomerInvitationRemove:
      return { ...state, removing: true, removed: false };

    case CustomerInvitationsActionTypes.CustomerInvitationRemoveSuccess:
      const oldInvitationsItem = action.payload;
      return { ...state, invitationsLoaded: true, invitationsLoading: false, invitations: state.invitations.filter(item => item.id !== oldInvitationsItem.id), removing: false, removed: true };

    case CustomerInvitationsActionTypes.CustomerInvitationRemoveFail:
      return { ...state, removing: false, removed: false };

    case CustomerInvitationsActionTypes.CustomerInvitationSendSuccess:
      const sentItem = action.payload;
      return {
        ...state,
        invitationsLoaded: true,
        invitationsLoading: false,
        invitations: state.invitations.map(item => (item.id === sentItem.id ? sentItem : item))
      };

    // Customer Invitations
    case CustomerInvitationsActionTypes.CustomersInvitationsLoadData:
      return { ...state, invitationsLoading: true, invitationsLoaded: false };
    case CustomerInvitationsActionTypes.CustomersInvitationsLoadSuccess:
      return { ...state, invitations: action.payload, invitationsLoading: false, invitationsLoaded: true };
    case CustomerInvitationsActionTypes.CustomersInvitationsLoadFail:
      return { ...state, invitations: [], invitationsLoading: false, invitationsLoaded: false };
  }
  return state;
}

export const getCustomerInvitations = (customerId: string) => (state: State) => state.invitations.filter(invitation => invitation.customerId === customerId);
export const getCustomerInvitationsLoading = (state: State) => state.invitationsLoading;
export const getCustomerInvitationsLoaded = (state: State) => state.invitationsLoaded;

// Invitation to single customer
export const getCustomerInvitationsCreated = (state: State) => state.created;
export const getCustomerInvitationsRemoved = (state: State) => state.removed;

// Invitations to multiple customers
export const getBulkCustomersInvitationsCreating = (state: State) => state.bulkInvitationsCreating;
export const getBulkCustomersInvitationsCreated = (state: State) => state.bulkInvitationsCreated;
export const getBulkCustomersInvitationsCompleted = (state: State) => state.bulkInvitationsCompleted;

export const getCustomersInvitations = (state: State) => state.invitations;
export const getCustomersInvitationsLoading = (state: State) => state.invitationsLoading;
export const getCustomersInvitationsLoaded = (state: State) => state.invitationsLoaded;
